var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7063 1.70711C20.0969 1.31658 20.0969 0.683417 19.7063 0.292893C19.3158 -0.0976312 18.6826 -0.0976312 18.2921 0.292893L16.156 2.42906L9.93782 1.3631C9.61963 1.30417 9.30437 1.32479 8.99207 1.42497C8.67976 1.52514 8.40576 1.69308 8.17006 1.92878L1.09899 8.99985C0.710079 9.38876 0.515625 9.86016 0.515625 10.4141C0.515625 10.968 0.710079 11.4394 1.09899 11.8283L8.17006 18.8993C8.55896 19.2883 9.03037 19.4827 9.58427 19.4827C10.1382 19.4827 10.6096 19.2883 10.9985 18.8993L18.0696 11.8283C18.3053 11.5926 18.4732 11.3186 18.5734 11.0063C18.6735 10.694 18.6942 10.3787 18.6352 10.0605L17.5695 3.84391L19.7063 1.70711ZM14.4216 4.16337L12.7921 5.79289C12.4016 6.18342 12.4016 6.81658 12.7921 7.20711C13.1826 7.59763 13.8158 7.59763 14.2063 7.20711L15.8352 5.57822L16.6553 10.4141L9.58427 17.4851L6.04874 13.9496L2.5132 10.4141L9.58427 3.34299L14.4216 4.16337Z",
    fill: "#2A2E3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintLabel);
export default __webpack_public_path__ + "static/media/print-label.839701b3af58037ca289ba99863a09eb.svg";
export { ForwardRef as ReactComponent };